import axios from 'axios'
import { useCallback } from 'react'

import { PROPERTY_TYPES } from '../../common/drmTypes'
import { PropertyDataTypes } from '../../redux/fetchAction'
import { useAppSelector } from '../../redux/hooks'
import { requestPropertyCrmTimelinePath } from './paths'
import { useDispatchFetch } from './useDispatchFetch'

export const useFetchPropertyCrmTimeline = () => {
  const tenantId = useAppSelector(state => state.myProfile.tenantId)
  const { dispatchError, dispatchFetching, dispatchSuccess } =
    useDispatchFetch()

  const fetchTimeline = useCallback(
    async (propertyId: string, propertyType?: PROPERTY_TYPES) => {
      if (!tenantId || !propertyId || !propertyType)
        return dispatchError(PropertyDataTypes.TIMELINE)

      const requestPath = requestPropertyCrmTimelinePath(
        propertyType,
        tenantId,
        propertyId
      )

      dispatchFetching(PropertyDataTypes.TIMELINE)

      const response = await axios.get(requestPath)
      if (response.status !== 200)
        return dispatchError(PropertyDataTypes.TIMELINE)

      const data = await response.data
      dispatchSuccess(PropertyDataTypes.TIMELINE, {
        ...data,
        type: propertyType,
      })
    },
    [dispatchError, dispatchFetching, dispatchSuccess, tenantId]
  )

  return fetchTimeline
}
